import {defineStore} from 'pinia'
import {CommonNs, ProjectNs, SettingNs, WorkspaceNs} from "@shared/types";
import {ProjectApi, WorkspaceMemberApi} from "@/api";


export const useWsMemberStore = defineStore("wsMember", {
    state: () => ({
        workspaceMembers: [] as WorkspaceNs.Member[],
        selectedMember: {} as WorkspaceNs.Member,
    }),
    getters: {
        getWorkspaceMembers: (state) => state.workspaceMembers,
        getWorkspaceMemberCount: (state) => state.workspaceMembers.length,
        getSelectedMember: (state) => state.selectedMember,
    },
    actions: {
        async loadWorkspaceMembers(
            workspaceId: string
        ): Promise<WorkspaceNs.Member[]> {
            return WorkspaceMemberApi.getWorkspaceMemberList(workspaceId)
                .then((members: WorkspaceNs.Member[]) => {
                    this.workspaceMembers = members
                    return members
                })
        },

        async loadMemberDetails(
            workspaceId: string, memberId: number
        ): Promise<WorkspaceNs.Member> {
            return WorkspaceMemberApi.getMemberDetails(workspaceId, memberId)
                .then((member: WorkspaceNs.Member) => {
                    this.selectedMember = member
                    return member
                })
        },

        async changeWorkspaceMemberRole(
            payload: WorkspaceNs.ChangeWorkspaceMemberRoleRequest
        ): Promise<CommonNs.AnyResponse> {
            return WorkspaceMemberApi.changeWorkspaceMemberRole(payload)
                .then((response) => response)
        },

        async changeWorkspaceMemberStatus(
            payload: WorkspaceNs.ChangeWorkspaceMemberStatusRequest
        ): Promise<CommonNs.AnyResponse> {
            return WorkspaceMemberApi.changeWorkspaceMemberStatus(payload)
                .then((response) => response)
        },

        async inviteMemberToWorkspace(
            payload: WorkspaceNs.InviteMembersRequest
        ): Promise<CommonNs.AnyResponse> {
            return WorkspaceMemberApi.inviteMemberToWorkspace(payload)
                .then((response) => response)
        },

        async addMemberToProject(
            payload: ProjectNs.ChangeProjectMemberStatusRequest
        ): Promise<ProjectNs.Member> {
            return ProjectApi.addMemberToProject(payload)
                .then((members: ProjectNs.Member) => members)
        },

        async deleteMemberFromProject(
            payload: ProjectNs.ChangeProjectMemberStatusRequest
        ): Promise<CommonNs.AnyResponse> {
            return ProjectApi.deleteMemberFromProject(payload)
                .then((response: CommonNs.AnyResponse) => response)
        },

        async changeProjectMemberRole(
            payload: ProjectNs.ChangeProjectMemberStatusRequest
        ): Promise<ProjectNs.Member> {
            return ProjectApi.changeProjectMemberRole(payload)
                .then((members: ProjectNs.Member) => members)
        },

        async deleteMemberFromWorkspace(
            payload: WorkspaceNs.RemoveWorkspaceMemberRequest
        ): Promise<CommonNs.AnyResponse> {
            return WorkspaceMemberApi.deleteMemberFromWorkspace(payload)
                .then((response: CommonNs.AnyResponse) => response)
        },

        async updateMemberInfo(
            payload: SettingNs.UpdateMemberInfoRequest
        ): Promise<CommonNs.AnyResponse> {
            return WorkspaceMemberApi.updateMemberInfo(payload)
                .then((response: CommonNs.AnyResponse) => response)
        }

    }
})
